<template>
  <DSEmojiPickerCategories v-model="category" />

  <DSEmojiPickerSearch v-model="search" />

  <DSEmojiPickerGrid
    :id="props.id"
    :sections="props.sections"
    :has-more-emojis="props.hasMoreEmojis"
    @hover="emit('hover', $event)"
    @select="selectEmoji"
    @load-more="emit('load-more')"
  />
</template>

<script setup lang="ts">
import DSEmojiPickerCategories from "@/src/design_system/button_and_controls/emoji_picker/components/DSEmojiPickerCategories.vue";
import DSEmojiPickerGrid from "@/src/design_system/button_and_controls/emoji_picker/components/DSEmojiPickerGrid.vue";
import DSEmojiPickerSearch from "@/src/design_system/button_and_controls/emoji_picker/components/DSEmojiPickerSearch.vue";
import type { EmojiPickerSection } from "@/src/design_system/button_and_controls/emoji_picker/types/panel";
import type { EmojiCategory, EmojiDisplayItem, EmojiSelection } from "@/src/shared/emoji/types";

const props = defineProps<{
  id: string;
  sections: EmojiPickerSection[];
  hasMoreEmojis: boolean;
}>();

const category = defineModel<EmojiCategory>("category", { required: true });
const search = defineModel<string>("search", { required: true });

const emit = defineEmits<{
  (e: "hover", emoji: EmojiDisplayItem): void;
  (e: "select", selection: EmojiSelection): void;
  (e: "load-more"): void;
}>();

const selectEmoji = (emoji: EmojiDisplayItem): void => {
  emit("select", { unicode: emoji.unicode, native: emoji.native });
};
</script>
